import { useRef, useEffect } from "react";

const DEFAULT_USE_TITLE_OPTIONS = {
  restoreOnUnmount: false,
};

function useSiteTitle(title: string, options = DEFAULT_USE_TITLE_OPTIONS) {
  const prevTitleRef = useRef(document.title);
  document.title = `${title} - MAT`;
  useEffect(() => {
    if (options && options.restoreOnUnmount) {
      return () => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        document.title = prevTitleRef.current;
      };
    } else {
      return;
    }
  }, [options]);
}

export default typeof document !== "undefined" ? useSiteTitle : () => {};
